/**
 * 독서 인증 — 단톡방에 붙여 넣는 한 줄.
 *
 * `닉네임/누적인증일/책제목/시작쪽/끝쪽/읽은시간(분)`
 *
 * 누적 인증일은 한국어책·영어책을 따로 센다. 원래는 설정에서 손으로 +1 하던
 * 값이었는데, 이제 복사 버튼이 그 날의 인증을 대신 기록한다.
 * 하루에 두 번 복사해도 하루는 하루이므로 `lastCertifiedDate` 로 막는다.
 */

import { isEnglishTitle } from './languageUtils';
import { CERTIFICATION_NAME } from '../constants';

export const CERT_TRACKS = {
  korean: { days: 'accumulatedDaysKorean', date: 'lastCertifiedDateKorean' },
  english: { days: 'accumulatedDaysEnglish', date: 'lastCertifiedDateEnglish' }
};

/** 책 제목으로 어느 누적일수에 넣을지 정한다 */
export const getCertTrack = (book) =>
  isEnglishTitle(book?.title || '') ? 'english' : 'korean';

/**
 * 이번 인증에 찍힐 날짜 번호.
 * 저장값은 '마지막 인증까지 끝낸 일수'이므로, 오늘 아직 인증하지 않았다면 +1 한 값이 오늘 몫이다.
 */
export const getCertificationDay = (userSettings, track, today) => {
  const fields = CERT_TRACKS[track] || CERT_TRACKS.korean;
  const stored = userSettings?.[fields.days] || 0;
  return userSettings?.[fields.date] === today ? stored : stored + 1;
};

/** 오늘 이미 인증을 눌렀는지 */
export const isCertifiedToday = (userSettings, track, today) => {
  const fields = CERT_TRACKS[track] || CERT_TRACKS.korean;
  return userSettings?.[fields.date] === today;
};

/**
 * 인증 한 줄을 만든다.
 *
 * 앞머리 이름은 단톡방에서 쓰는 필명이라 언제나 CERTIFICATION_NAME 이다.
 * 설정의 '화면에 보이는 이름'을 바꿔도 여기는 흔들리지 않아야, 그동안 올린
 * 인증과 이어진다. 인자로도 받아 두어 시험할 때만 다른 이름을 넣는다.
 */
export const buildCertificationText = ({
  nickname = CERTIFICATION_NAME, day, title, startPage, endPage, minutes
}) => `${nickname}/${day}/${title}/${startPage}/${endPage}/${Math.round(minutes || 0)}`;
